import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './PurchaseOrders.frontend.types'

@Injectable({ providedIn: 'root' })
export class PurchaseOrders_create_damage_receiving_task_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { orderId: number, linenumber: number, shipmentId: number, packagingId: number, packagedAmount: number }): Promise<{ reason?: string }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.orderId)) {
      $missingRequiredInParams.push('\'orderId\'');
    }
    if (isNil($inParams.linenumber)) {
      $missingRequiredInParams.push('\'linenumber\'');
    }
    if (isNil($inParams.shipmentId)) {
      $missingRequiredInParams.push('\'shipmentId\'');
    }
    if (isNil($inParams.packagingId)) {
      $missingRequiredInParams.push('\'packagingId\'');
    }
    if (isNil($inParams.packagedAmount)) {
      $missingRequiredInParams.push('\'packagedAmount\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

